import { Component, EventEmitter, Output, input } from '@angular/core';

@Component({
    selector: 'lib-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    standalone: false
})
export class BackButtonComponent {
  label = input<string>('Back');
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();
}
